export default "__VITE_ASSET__C0wx3yR2__"